import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import {
  getSelfRequest,
  updateSelfRequest,
  updateSelfPwdRequest,
  createAdminRequest,
  updateAdminRequest,
  resetAdminPwdRequest,
  toggleAdminStatusRequest,
  getAdminsRequest,
  getIssuerProfileRequest,
  updateIssuerSelfRequest,
  updateIssuerSelfPwdRequest,
  createIssuerRequest,
  getIssuerStaffsRequest,
  updateIssuerStaffRequest,
  resetIssuerStaffPwdRequest,
  toggleIssuerStatusRequest
} from 'src/api/StaffRequest';
import { requestWrapper } from 'src/utils/utils';
import { GETSTAFF_SUCCESS, GET_SELF } from '../types';
import { checkRequestError } from '.';

export const actionRequest = (type, payload) => ({
  type,
  payload
});

export const getStaff = (profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile.super == 1
          ? await getAdminsRequest()
          : await getIssuerStaffsRequest();
      checkRequestError(data);

      dispatch({ type: GETSTAFF_SUCCESS, payload: data.content.data.all });
      return { message: data.success.message, status: 1 };
    } catch (error) {
      return { message: error.message, status: 0 };
    }
  };
};

export const createStaff = (obj, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile.super == 1
          ? await createAdminRequest(requestWrapper(obj))
          : await createIssuerRequest(requestWrapper(obj));
      checkRequestError(data);

      await dispatch(getStaff(profile));
      NotificationManager.success('Staff created successfully', 'Success');
      return { message: data.success.message, status: 1 };
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return { message: error.message, status: 0 };
    }
  };
};

export const updateStaff = (id, obj, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile.super == 1
          ? await updateAdminRequest(id, requestWrapper(obj))
          : await updateIssuerStaffRequest(id, requestWrapper(obj));
      checkRequestError(data);

      await dispatch(getStaff(profile));
      NotificationManager.success('Staff updated successfully', 'Success');
      return { message: data.success.message, status: 1 };
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return { message: error.message, status: 0 };
    }
  };
};

export const resetStaffPwd = (id, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile.super == 1
          ? await resetAdminPwdRequest(id)
          : await resetIssuerStaffPwdRequest(id);
      checkRequestError(data);

      NotificationManager.success(data.success.message, 'Success');
      return { message: data.success.message, status: 1 };
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return { message: error.message, status: 0 };
    }
  };
};

export const toggleStaffStatus = (id, payload, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile.super == 1
          ? await toggleAdminStatusRequest(id, requestWrapper(payload))
          : await toggleIssuerStatusRequest(id, requestWrapper(payload));
      checkRequestError(data);

      dispatch(getStaff(profile));
      NotificationManager.success(data.success.message, 'Success');
      return { message: data.success.message, status: 1 };
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return { message: error.message, status: 0 };
    }
  };
};

export const updateStaffPassword = (obj, profile) => {
  return async (dispatch) => {
    try {
      const { oldPassword, newPassword } = obj;
      const reqObj = {
        data: {
          oldPassword,
          newPassword
        }
      };

      const { data } =
        profile.super == 1
          ? await updateSelfPwdRequest(reqObj)
          : await updateIssuerSelfPwdRequest(reqObj);

      if (data?.error?.status >= 400) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      }
      NotificationManager.success('Password Updated', 'Success');
      return 1;
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const getSelfAction = (profile) => async (dispatch) => {
  try {
    const { data } =
      profile.super == 1
        ? await getSelfRequest()
        : await getIssuerProfileRequest();
    checkRequestError(data);

    dispatch(actionRequest(GET_SELF, data.content.data));
    return { message: data.success.message, status: 1 };
  } catch (error) {
    console.log('Error: getSelfAction - ', error);
    return { message: error.message, status: 0 };
  }
};

export const updateSelfAction = (values, profile) => async (dispatch) => {
  try {
    const { data } =
      profile.super == 1
        ? await updateSelfRequest(requestWrapper(values))
        : await updateIssuerSelfRequest(requestWrapper(values));
    checkRequestError(data);

    NotificationManager.success(data.success.message, 'Success');
    dispatch(getSelfAction(profile));
    return { message: data.success.message, status: 1 };
  } catch (error) {
    console.log('Error: updateSelfAction - ', error);
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};
